import { gql, useMutation } from "@apollo/client"
import { noop } from "lodash-es"
import { DestroyCreditNoteInput, DestroyCreditNotePayload } from "@oysterhr/schema"

export const INVOICING_COMPANY_DELETE_CREDIT_NOTE = gql`
  mutation InvoicingCompanyDeleteCreditNote($creditNoteId: String!) {
    destroyCreditNote(input: { creditNoteId: $creditNoteId }) {
      __typename
    }
  }
`

export const useDestroyCreditNote = ({ onCompleted = noop }: { onCompleted: () => void }) =>
  useMutation<
    { destroyCreditNote: Pick<DestroyCreditNotePayload, "__typename"> },
    DestroyCreditNoteInput
  >(INVOICING_COMPANY_DELETE_CREDIT_NOTE, { onCompleted })
